import { Box, Typography, TextField, Button, Grid, IconButton, InputAdornment, CircularProgress, Link, Select, MenuItem, FormControl } from '@mui/material';
import COLORS from '../../../../constants/colors';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faLock, faEnvelope, faEye, faEyeSlash, faPhone, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import Header from './Header';
import SnackbarAlert from '../Reusbale/SnackbarAlert';
import baseURL from '../config';
import { useNavigate } from "react-router-dom";
import GoogleLoginButton from '../Register/GoogleLogin';
import Footer from '../../../Reusable/Footer';
import { toast } from 'react-toastify';

// 🌍 All Countries (East Africa prioritized, abbr = name)
const countryCodes = [
  // --- East African Countries (prioritized) ---
  { code: '+256', name: 'Uganda', abbr: 'Uganda' },
  { code: '+254', name: 'Kenya', abbr: 'Kenya' },
  { code: '+255', name: 'Tanzania', abbr: 'Tanzania' },
  { code: '+250', name: 'Rwanda', abbr: 'Rwanda' },
  { code: '+257', name: 'Burundi', abbr: 'Burundi' },
  { code: '+211', name: 'South Sudan', abbr: 'South Sudan' },
  { code: '+251', name: 'Ethiopia', abbr: 'Ethiopia' },
  { code: '+252', name: 'Somalia', abbr: 'Somalia' },
  { code: '+260', name: 'Zambia', abbr: 'Zambia' },
  { code: '+263', name: 'Zimbabwe', abbr: 'Zimbabwe' },

  // --- Rest of the World (alphabetically) ---
  { code: '+93', name: 'Afghanistan', abbr: 'Afghanistan' },
  { code: '+355', name: 'Albania', abbr: 'Albania' },
  { code: '+213', name: 'Algeria', abbr: 'Algeria' },
  { code: '+1-684', name: 'American Samoa', abbr: 'American Samoa' },
  { code: '+376', name: 'Andorra', abbr: 'Andorra' },
  { code: '+244', name: 'Angola', abbr: 'Angola' },
  { code: '+1-264', name: 'Anguilla', abbr: 'Anguilla' },
  { code: '+1-268', name: 'Antigua and Barbuda', abbr: 'Antigua and Barbuda' },
  { code: '+54', name: 'Argentina', abbr: 'Argentina' },
  { code: '+374', name: 'Armenia', abbr: 'Armenia' },
  { code: '+297', name: 'Aruba', abbr: 'Aruba' },
  { code: '+61', name: 'Australia', abbr: 'Australia' },
  { code: '+43', name: 'Austria', abbr: 'Austria' },
  { code: '+994', name: 'Azerbaijan', abbr: 'Azerbaijan' },
  { code: '+1-242', name: 'Bahamas', abbr: 'Bahamas' },
  { code: '+973', name: 'Bahrain', abbr: 'Bahrain' },
  { code: '+880', name: 'Bangladesh', abbr: 'Bangladesh' },
  { code: '+1-246', name: 'Barbados', abbr: 'Barbados' },
  { code: '+375', name: 'Belarus', abbr: 'Belarus' },
  { code: '+32', name: 'Belgium', abbr: 'Belgium' },
  { code: '+501', name: 'Belize', abbr: 'Belize' },
  { code: '+229', name: 'Benin', abbr: 'Benin' },
  { code: '+975', name: 'Bhutan', abbr: 'Bhutan' },
  { code: '+591', name: 'Bolivia', abbr: 'Bolivia' },
  { code: '+387', name: 'Bosnia and Herzegovina', abbr: 'Bosnia and Herzegovina' },
  { code: '+267', name: 'Botswana', abbr: 'Botswana' },
  { code: '+55', name: 'Brazil', abbr: 'Brazil' },
  { code: '+673', name: 'Brunei Darussalam', abbr: 'Brunei Darussalam' },
  { code: '+359', name: 'Bulgaria', abbr: 'Bulgaria' },
  { code: '+226', name: 'Burkina Faso', abbr: 'Burkina Faso' },
  { code: '+855', name: 'Cambodia', abbr: 'Cambodia' },
  { code: '+237', name: 'Cameroon', abbr: 'Cameroon' },
  { code: '+1', name: 'Canada', abbr: 'Canada' },
  { code: '+238', name: 'Cape Verde', abbr: 'Cape Verde' },
  { code: '+56', name: 'Chile', abbr: 'Chile' },
  { code: '+86', name: 'China', abbr: 'China' },
  { code: '+57', name: 'Colombia', abbr: 'Colombia' },
  { code: '+269', name: 'Comoros', abbr: 'Comoros' },
  { code: '+243', name: 'Congo (Democratic Republic)', abbr: 'Congo (Democratic Republic)' },
  { code: '+242', name: 'Congo (Republic)', abbr: 'Congo (Republic)' },
  { code: '+506', name: 'Costa Rica', abbr: 'Costa Rica' },
  { code: '+385', name: 'Croatia', abbr: 'Croatia' },
  { code: '+53', name: 'Cuba', abbr: 'Cuba' },
  { code: '+357', name: 'Cyprus', abbr: 'Cyprus' },
  { code: '+420', name: 'Czech Republic', abbr: 'Czech Republic' },
  { code: '+45', name: 'Denmark', abbr: 'Denmark' },
  { code: '+20', name: 'Egypt', abbr: 'Egypt' },
  { code: '+503', name: 'El Salvador', abbr: 'El Salvador' },
  { code: '+372', name: 'Estonia', abbr: 'Estonia' },
  { code: '+251', name: 'Ethiopia', abbr: 'Ethiopia' },
  { code: '+358', name: 'Finland', abbr: 'Finland' },
  { code: '+33', name: 'France', abbr: 'France' },
  { code: '+49', name: 'Germany', abbr: 'Germany' },
  { code: '+233', name: 'Ghana', abbr: 'Ghana' },
  { code: '+30', name: 'Greece', abbr: 'Greece' },
  { code: '+852', name: 'Hong Kong', abbr: 'Hong Kong' },
  { code: '+36', name: 'Hungary', abbr: 'Hungary' },
  { code: '+354', name: 'Iceland', abbr: 'Iceland' },
  { code: '+91', name: 'India', abbr: 'India' },
  { code: '+62', name: 'Indonesia', abbr: 'Indonesia' },
  { code: '+98', name: 'Iran', abbr: 'Iran' },
  { code: '+964', name: 'Iraq', abbr: 'Iraq' },
  { code: '+353', name: 'Ireland', abbr: 'Ireland' },
  { code: '+972', name: 'Israel', abbr: 'Israel' },
  { code: '+39', name: 'Italy', abbr: 'Italy' },
  { code: '+81', name: 'Japan', abbr: 'Japan' },
  { code: '+962', name: 'Jordan', abbr: 'Jordan' },
  { code: '+7', name: 'Kazakhstan', abbr: 'Kazakhstan' },
  { code: '+850', name: 'North Korea', abbr: 'North Korea' },
  { code: '+82', name: 'South Korea', abbr: 'South Korea' },
  { code: '+965', name: 'Kuwait', abbr: 'Kuwait' },
  { code: '+856', name: 'Laos', abbr: 'Laos' },
  { code: '+371', name: 'Latvia', abbr: 'Latvia' },
  { code: '+961', name: 'Lebanon', abbr: 'Lebanon' },
  { code: '+231', name: 'Liberia', abbr: 'Liberia' },
  { code: '+218', name: 'Libya', abbr: 'Libya' },
  { code: '+423', name: 'Liechtenstein', abbr: 'Liechtenstein' },
  { code: '+370', name: 'Lithuania', abbr: 'Lithuania' },
  { code: '+352', name: 'Luxembourg', abbr: 'Luxembourg' },
  { code: '+853', name: 'Macau', abbr: 'Macau' },
  { code: '+389', name: 'North Macedonia', abbr: 'North Macedonia' },
  { code: '+261', name: 'Madagascar', abbr: 'Madagascar' },
  { code: '+265', name: 'Malawi', abbr: 'Malawi' },
  { code: '+60', name: 'Malaysia', abbr: 'Malaysia' },
  { code: '+960', name: 'Maldives', abbr: 'Maldives' },
  { code: '+223', name: 'Mali', abbr: 'Mali' },
  { code: '+356', name: 'Malta', abbr: 'Malta' },
  { code: '+52', name: 'Mexico', abbr: 'Mexico' },
  { code: '+377', name: 'Monaco', abbr: 'Monaco' },
  { code: '+212', name: 'Morocco', abbr: 'Morocco' },
  { code: '+264', name: 'Namibia', abbr: 'Namibia' },
  { code: '+977', name: 'Nepal', abbr: 'Nepal' },
  { code: '+31', name: 'Netherlands', abbr: 'Netherlands' },
  { code: '+64', name: 'New Zealand', abbr: 'New Zealand' },
  { code: '+234', name: 'Nigeria', abbr: 'Nigeria' },
  { code: '+47', name: 'Norway', abbr: 'Norway' },
  { code: '+968', name: 'Oman', abbr: 'Oman' },
  { code: '+92', name: 'Pakistan', abbr: 'Pakistan' },
  { code: '+970', name: 'Palestine', abbr: 'Palestine' },
  { code: '+507', name: 'Panama', abbr: 'Panama' },
  { code: '+595', name: 'Paraguay', abbr: 'Paraguay' },
  { code: '+51', name: 'Peru', abbr: 'Peru' },
  { code: '+63', name: 'Philippines', abbr: 'Philippines' },
  { code: '+48', name: 'Poland', abbr: 'Poland' },
  { code: '+351', name: 'Portugal', abbr: 'Portugal' },
  { code: '+974', name: 'Qatar', abbr: 'Qatar' },
  { code: '+40', name: 'Romania', abbr: 'Romania' },
  { code: '+7', name: 'Russia', abbr: 'Russia' },
  { code: '+966', name: 'Saudi Arabia', abbr: 'Saudi Arabia' },
  { code: '+65', name: 'Singapore', abbr: 'Singapore' },
  { code: '+27', name: 'South Africa', abbr: 'South Africa' },
  { code: '+34', name: 'Spain', abbr: 'Spain' },
  { code: '+94', name: 'Sri Lanka', abbr: 'Sri Lanka' },
  { code: '+46', name: 'Sweden', abbr: 'Sweden' },
  { code: '+41', name: 'Switzerland', abbr: 'Switzerland' },
  { code: '+963', name: 'Syria', abbr: 'Syria' },
  { code: '+886', name: 'Taiwan', abbr: 'Taiwan' },
  { code: '+66', name: 'Thailand', abbr: 'Thailand' },
  { code: '+90', name: 'Turkey', abbr: 'Turkey' },
  { code: '+256', name: 'Uganda', abbr: 'Uganda' },
  { code: '+380', name: 'Ukraine', abbr: 'Ukraine' },
  { code: '+971', name: 'United Arab Emirates', abbr: 'United Arab Emirates' },
  { code: '+44', name: 'United Kingdom', abbr: 'United Kingdom' },
  { code: '+1', name: 'United States', abbr: 'United States' },
  { code: '+598', name: 'Uruguay', abbr: 'Uruguay' },
  { code: '+998', name: 'Uzbekistan', abbr: 'Uzbekistan' },
  { code: '+58', name: 'Venezuela', abbr: 'Venezuela' },
  { code: '+84', name: 'Vietnam', abbr: 'Vietnam' },
  { code: '+260', name: 'Zambia', abbr: 'Zambia' },
  { code: '+263', name: 'Zimbabwe', abbr: 'Zimbabwe' },
];


const Register = () => {
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();
    const [agreedToTerms, setAgreedToTerms] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    
    // Default the country code to Uganda (+256)
    const [selectedCode, setSelectedCode] = useState('+256'); 

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        physicalAddress: '',
        password: '',
        confirmPassword: ''
    });

    const [loading, setLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

    const handleChange = (e) => {
        let { name, value } = e.target;

        if (name === 'phone') {
            // New Logic: Remove leading '0' if it exists
            if (value.startsWith('0')) {
                value = value.substring(1);
            }
            // Ensure only digits are entered
            value = value.replace(/\D/g, '');
        }

        setFormData({ ...formData, [name]: value });
    };

    const handleCodeChange = (e) => {
        setSelectedCode(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const fullPhoneNumber = `${selectedCode}${formData.phone}`;

        // ---- validation ----------------------------------------------------------
        if (
            !formData.name ||
            !formData.email ||
            !formData.phone || 
            !formData.physicalAddress ||
            !formData.password ||
            !formData.confirmPassword
        ) {
            toast.error('All fields are required!');
            setLoading(false);
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.email)) {
            toast.error('Please enter a valid email address.');
            setLoading(false);
            return;
        }

        // Basic validation for the combined phone number (starts with '+', 8 to 15 digits)
        const internationalPhoneRegex = /^\+\d{8,15}$/; 
        if (!internationalPhoneRegex.test(fullPhoneNumber)) {
            toast.error('Please enter a valid international phone number (8 to 15 digits).');
            setLoading(false);
            return;
        }

        const passwordRegex =
            /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
        if (!passwordRegex.test(formData.password)) {
            toast.error(
                'Password must be at least 8 characters, include one letter, one number, and one special character.'
            );
            setLoading(false);
            return;
        }

        if (formData.password !== formData.confirmPassword) {
            toast.error('Passwords do not match!');
            setLoading(false);
            return;
        }

        // ---- submit --------------------------------------------------------------
        try {
            const payload = { 
                ...formData, 
                phone: fullPhoneNumber // Send the full international number
            };

            const response = await fetch(`${baseURL}/auth/user/register`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Something went wrong');
            }

            toast.success(
                data.message ||
                'Registration successful! Please check your email for a verification link.'
            );

            // reset form and code
            setFormData({
                name: '',
                email: '',
                phone: '',
                physicalAddress: '',
                password: '',
                confirmPassword: '',
            });
            setSelectedCode(countryCodes[0].code);

            setTimeout(() => navigate('/user/login'), 2000);
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    return (
        <Box>
            <Header />
            <Box sx={{ py: 3, px: 3, maxWidth: 600, margin: '0 auto', textAlign: 'center' }}>
                <Typography variant="h4" fontWeight="bold" color={COLORS.primary} mb={2}>
                    Create an Account
                </Typography>
                <Typography variant="body1" color={COLORS.text} mb={4}>
                    Sign up and start exploring today.
                </Typography>

                {/* Social Login Buttons */}
                <Grid container spacing={2} mb={3}>
                    <Grid item xs={12} sm={12}>
                        <GoogleLoginButton />
                    </Grid>
                </Grid>

                {/* Registration Form */}
                <Box component="form" noValidate autoComplete="off" onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <TextField name="name" label="Full Name" variant="outlined" fullWidth value={formData.name} onChange={handleChange} sx={{ mb: 3, '& .MuiOutlinedInput-root': { borderRadius: '10px' } }} InputLabelProps={{ style: { color: COLORS.primary } }} InputProps={{ style: { color: COLORS.text }, startAdornment: (<InputAdornment position="start"><FontAwesomeIcon icon={faUser} style={{ color: COLORS.primary }} /></InputAdornment>) }} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField name="email" label="Email Address" variant="outlined" fullWidth value={formData.email} onChange={handleChange} sx={{ mb: 3, '& .MuiOutlinedInput-root': { borderRadius: '10px' } }} InputLabelProps={{ style: { color: COLORS.primary } }} InputProps={{ style: { color: COLORS.text }, startAdornment: (<InputAdornment position="start"><FontAwesomeIcon icon={faEnvelope} style={{ color: COLORS.primary }} /></InputAdornment>) }} />
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} sx={{ mb: 3 }}>
                        <Grid item xs={4} sm={3}>
                            {/* Country Code Select Dropdown */}
                            <FormControl fullWidth variant="outlined" sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}>
                                <Select
                                    value={selectedCode}
                                    onChange={handleCodeChange}
                                    sx={{ color: COLORS.primary, fontWeight: 'bold' }}
                                    inputProps={{ 'aria-label': 'Country Code' }}
                                >
                                    {countryCodes.map((country) => (
                                        <MenuItem key={country.code} value={country.code}>
                                            {/* Combined format: UGA +256 */}
                                            {country.abbr} {country.code} 
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={8} sm={9}>
                            {/* Phone Number Input */}
                            <TextField
                                name="phone"
                                label="Phone Number (Exclude leading 0)"
                                variant="outlined"
                                fullWidth
                                value={formData.phone}
                                onChange={handleChange}
                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                                InputLabelProps={{ style: { color: COLORS.primary } }}
                                InputProps={{
                                    style: { color: COLORS.text },
                                    startAdornment: (<InputAdornment position="start"><FontAwesomeIcon icon={faPhone} style={{ color: COLORS.primary }} /></InputAdornment>),
                                    inputProps: { inputMode: "numeric" }
                                }}
                            />
                        </Grid>
                    </Grid>

                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField name="physicalAddress" label="Physical Address" variant="outlined" fullWidth value={formData.physicalAddress} onChange={handleChange} sx={{ mb: 3, '& .MuiOutlinedInput-root': { borderRadius: '10px' } }} InputLabelProps={{ style: { color: COLORS.primary } }} InputProps={{ style: { color: COLORS.text }, startAdornment: (<InputAdornment position="start"><FontAwesomeIcon icon={faMapMarkerAlt} style={{ color: COLORS.primary }} /></InputAdornment>) }} />
                        </Grid>
                    </Grid>

                    <TextField
                        name="password"
                        label="Password"
                        variant="outlined"
                        fullWidth
                        type={showPassword ? "text" : "password"}
                        value={formData.password}
                        onChange={handleChange}
                        sx={{ mb: 3, '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                        InputLabelProps={{ style: { color: COLORS.primary } }}
                        InputProps={{
                            style: { color: COLORS.text },
                            startAdornment: (<InputAdornment position="start"><FontAwesomeIcon icon={faLock} style={{ color: COLORS.primary }} /></InputAdornment>),
                            endAdornment: (<InputAdornment position="end"><IconButton onClick={() => setShowPassword(!showPassword)} edge="end"><FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} style={{ fontSize: '16px' }} /></IconButton></InputAdornment>)
                        }}
                    />

                    {/* Confirm Password Field */}
                    <TextField
                        name="confirmPassword"
                        label="Confirm Password"
                        variant="outlined"
                        fullWidth
                        type={showConfirmPassword ? "text" : "password"}
                        value={formData.confirmPassword}
                        onChange={handleChange}
                        sx={{ mb: 3, '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                        InputLabelProps={{ style: { color: COLORS.primary } }}
                        InputProps={{
                            style: { color: COLORS.text },
                            startAdornment: (<InputAdornment position="start"><FontAwesomeIcon icon={faLock} style={{ color: COLORS.primary }} /></InputAdornment>),
                            endAdornment: (<InputAdornment position="end"><IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)} edge="end"><FontAwesomeIcon icon={showConfirmPassword ? faEyeSlash : faEye} style={{ fontSize: '16px' }} /></IconButton></InputAdornment>)
                        }}
                    />

                    <Box display="flex" alignItems="center" mb={2}>
                        <input
                            type="checkbox"
                            id="terms"
                            checked={agreedToTerms}
                            onChange={(e) => setAgreedToTerms(e.target.checked)}
                            style={{ marginRight: 8 }}
                        />
                        <label htmlFor="terms" style={{ color: COLORS.text, fontSize: '0.875rem' }}>
                            I agree to the&nbsp;
                            <Link href="/terms-of-use" target="_blank" rel="noopener" underline="hover" style={{ color: COLORS.primary, textDecoration: 'underline', fontWeight: 'bold' }}>
                                Terms of Use
                            </Link>{" "}
                            and&nbsp;
                            <Link href="/privacy-policy" target="_blank" rel="noopener" underline="hover" style={{ color: COLORS.primary, textDecoration: 'underline', fontWeight: 'bold' }}>
                                Privacy Policy
                            </Link>
                        </label>
                    </Box>



                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        disabled={!agreedToTerms || loading}
                        sx={{
                            backgroundColor: COLORS.primary,
                            color: COLORS.white,
                            borderRadius: '10px',
                            py: 1.5,
                            fontSize: '0.9rem',
                            textTransform: 'none',
                            '&:hover': { backgroundColor: COLORS.secondary }
                        }}
                    >
                        {loading ? <CircularProgress size={24} color="inherit" /> : 'Register'}
                    </Button>

                </Box>

                <Box mt={2}>
                    <Typography variant="body2" color={COLORS.text}>
                        Already have an account?{" "}
                        <span
                            onClick={() => navigate("/user/login")}
                            style={{ color: COLORS.primary, cursor: "pointer", fontWeight: "bold", textDecoration: "none" }}
                        >
                            Login
                        </span>
                    </Typography>
                </Box>
            </Box>

            {/* Snackbar for Messages */}
            <SnackbarAlert open={snackbar.open} message={snackbar.message} severity={snackbar.severity} handleClose={handleCloseSnackbar} />
            <Footer />
        </Box>
    );
};

export default Register;